/** App API del módulo Compras — intake functions (application layer).
 * Depende de domain-api + infra-api. Importar desde acá para evitar require cycles. */

// purchaseIntake
export {
  createPurchaseOrderIntake,
  voidPurchaseOrderIntake,
  closePurchaseOrderIntake,
  sendPurchaseOrderIntake,
  createPurchaseReceptionIntake,
  voidPurchaseReceptionIntake,
  createPurchaseReturnIntake,
  voidPurchaseReturnIntake,
  createStockTransferIntake,
  voidStockTransferIntake,
} from './application/purchaseIntake';

// pullPurchasesWhenNeeded
export { pullPurchasesWhenNeeded } from './application/pullPurchasesWhenNeeded';
